import { Button, TOUCH } from "@nymbl/nos2-rules";
// src/components/time/TodayChip.tsx
import { Link } from "@tanstack/react-router";
import { Timer } from "lucide-react";
import { useTodayHours } from "@/hooks/use-time-week";
import { todayChip } from "@/lib/time/today";
import { cn } from "@/lib/utils";

/**
 * "Today: 6.5 hrs" in the page header (My NOS parity, TE-37), on Home and Time. Opens Time on
 * today. Hidden at 0 hrs and while the week loads or fails (rule 7).
 */
interface TodayChipProps {
  /** Phones only: leave the room to the page's own actions (a crowded header row). */
  hideOnPhone?: boolean;
}

export function TodayChip({ hideOnPhone = false }: TodayChipProps) {
  const { today, hours } = useTodayHours();
  const copy = hours === null ? null : todayChip(hours);
  if (!copy) return null;
  return (
    <Button
      asChild
      variant="outline"
      className={cn(
        TOUCH,
        "rounded-full max-xl:px-2",
        hideOnPhone && "max-md:hidden",
        copy.full && "text-success",
      )}
    >
      {/* No aria-label: the name is the visible text plus a hidden suffix ("6.5h logged today"),
          and the span not shown at this width drops out of the name with its suffix. */}
      <Link to="/dashboard/time" search={{ day: today }}>
        <Timer className="size-4 max-xl:hidden" aria-hidden="true" />
        <span className="hidden tabular-nums xl:inline">
          {copy.text}
          <span className="sr-only">{copy.textSuffix}</span>
        </span>
        <span className="tabular-nums xl:hidden">
          {copy.short}
          <span className="sr-only">{copy.shortSuffix}</span>
        </span>
      </Link>
    </Button>
  );
}
